
const ContactHero = () => {
  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url('https://public.readdy.ai/ai/img_res/7753d51b949492ec8fe8fae8a1d20c6e.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Contact Our <span className="text-teal-400">Chemical Experts</span>
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-200">
          Get in touch with our experienced engineers for customized chemical solutions and technical support
        </p>
      </div>
    </section>
  );
};

export default ContactHero;
